<template>
    <div>
        <h3 class="mt-3">Date / Location</h3>

        <div class="row mt-5" v-if="getIsCreatSingleEvent">

            <div class="col-sm-4">
                <label class="full" :class="{'color-6':validations.getSelectedEvent.product.$invalid}">
                    Product<span class="color-6">*</span>
                </label>
                <div class="d-flex align-items-center">
                    <span class="font-size-small dark" v-if="isLoadingProductList">Loading products</span>
                    <v-select v-else :searchable="true" :options="productList" label="name" placeholder="Select a product" v-model="getSelectedEvent.helperProduct" @input="changeProductSelected"></v-select>
                </div>
            </div>

            <!-- <div class="col-sm-6">
            <label class="full">
            Category
            </label>
            <v-select :searchable="false" :options="categoryList" label="name" placeholder="All" v-model="selectedCategory" @input="changeCategorySelected"></v-select>
        </div> -->

        </div>

        <div class="row mt-2">
            <div class="col-sm-5">
                <label class="full">
                    Event Name
                </label>
                <input type="text" class="bg-lightest w-100" v-model="getSelectedEvent.nameAlias" :placeholder="getSelectedEvent.product? getSelectedEvent.product.name : '' ">
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-sm-4">
                <label class="full">
                    Event Date<span class="color-6">*</span>
                </label>
                <datepicker input-class="bg-lightest" :value="getSelectedEvent.start" @input="setEventStartDate" format="dd/MM/yyyy"></datepicker>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-sm-5">
                <label class="full">
                    Time<span class="color-6">*</span>
                </label>
                <timepicker format="hh:mm" :defaultTime="eventStartHour" @change="setEventStartTime"></timepicker>
            </div>

            <div class="col-sm-5">
                <label class="full" :class="{'color-6':validations.getSelectedEvent.end.$invalid}">
                    Duration<span class="color-6">*</span>
                    <span class="color-6 fs-smaller" v-if="validations.getSelectedEvent.end.$invalid">Select a valid duration</span>
                </label>
                <timepicker :defaultTime="eventDuration" @change="setEventEndTime" :availableHours="durationsPossibleHours" format="hh:mm"></timepicker>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-sm-5">
                <label class="full" :class="{'color-6':validations.getSelectedEvent.location.$invalid}">
                    Location<span class="color-6">*</span>
                    <span class="color-6 fs-smaller" v-if="validations.getSelectedEvent.location.$invalid">Enter a location</span>
                </label>
                <input type="text" class="bg-lightest w-100" v-model="getSelectedEvent.location" placeholder="Type event location">
            </div>
        </div>

    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'
    import Timepicker from '@/tools/Timepicker'
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        props: {
            validations: {
                type: Object
            }
        },
        created: function() {
            //based on the event ending time calculates the duration and stores it
            this.storedEventDuration = moment(this.getSelectedEvent.end).diff(moment(this.getSelectedEvent.start), 'seconds');

            if(this.getIsCreatSingleEvent){
                this.getProducts();
            }

            // if(this.getSelectedEvent.nameAlias == null){
            //     if(this.getSelectedEvent.product){
            //         this.getSelectedEvent.nameAlias = this.getSelectedEvent.product.name
            //     } else {
            //
            //     }
            //     // this.getSelectedEvent.nameAlias = 'New event'
            // }
        },
        data: function() {
            return {
                storedEventDuration: null,
                eventDurationDisplayed: "02:00",
                durationsPossibleHours:['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
                isLoadingProductList: false,
                productList: [],        //used when creating new single event
                categoryList: [],       //used when creating new single event
                selectedCategory: null,
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getSelectedEvent',
                'getIsCreatSingleEvent'
            ]),
            eventStartHour: function(){
                return [moment(this.getSelectedEvent.start).format('HH'), moment(this.getSelectedEvent.start).format('mm')]
            },
            eventDuration: function(){
                var timeStart = moment(this.getSelectedEvent.start);
                var timeEnd = moment(this.getSelectedEvent.end);

                var duration = timeEnd.diff(timeStart)

                return [moment.utc(duration).format('HH'), moment.utc(duration).format('mm')]
            },
            eventDurationsInSeconds: function(){
                let timeArr = this.eventDurationDisplayed.split(":");
                return moment.duration(timeArr[0]+":"+timeArr[1], "HH:mm").asSeconds();
            }
        },
        methods: {
            setEventStartTime: function(e){
                let timeArr = e.split(":");
                this.getSelectedEvent.start = moment(this.getSelectedEvent.start).set({hour:timeArr[0],minute:timeArr[1]}).format('YYYY-MM-DD HH:mm:ss');

                this.getSelectedEvent.end = moment(this.getSelectedEvent.start).add(this.storedEventDuration, 'seconds').format('YYYY-MM-DD HH:mm:ss');
            },
            setEventStartDate: function(e){
                // console.log(e);
                this.getSelectedEvent.start = moment(e).format('YYYY-MM-DD HH:mm:ss');
                this.getSelectedEvent.end = moment(e).add(this.eventDurationsInSeconds, 'second').format('YYYY-MM-DD HH:mm:ss');
            },
            setEventEndTime: function(e){
                console.log('setEventEndTime', e);
                let timeArr = e.split(":");
                this.eventDurationDisplayed = e;
                this.storedEventDuration = ((timeArr[0] * 3600) + (timeArr[1] * 60))
                this.getSelectedEvent.end = moment(this.getSelectedEvent.start).add(this.eventDurationsInSeconds, 'second').format('YYYY-MM-DD HH:mm:ss');
                this.getSelectedEvent.duration = e +':00'
            },
            getProducts: function() {
                this.isLoadingProductList = true;
                axios.get('/api/booking/Resume', {
                    params: {
                        supplierId: this.account.supplierId
                    }
                }).then(response => {
                    this.isLoadingProductList = false;
                    if(response.status == 200){
                        this.productList = response.data.productList
                        this.categoryList = response.data.categoryList
                    }
                }).catch(error => {
                    this.isLoadingProductList = false;
                })
            },
            changeProductSelected: function() {

                console.log('getSelectedEvent.helperProduct', this.getSelectedEvent.helperProduct);

                //set max ocupation
                if(!this.getSelectedEvent.maximumLotation || this.getSelectedEvent.maximumLotation == 0 || this.getSelectedEvent.maximumLotation == null){
                    this.getSelectedEvent.maximumLotation = this.getSelectedEvent.helperProduct.capacity
                }

                //set prices
                // this.getSelectedEvent.eventGenderPrices = this.getSelectedEvent.helperProduct.productGenderPrices

                //removes id's to prevent the edit event from editing the parent product
                // if(this.getSelectedEvent.eventGenderPrices.length > 0){
                //
                //     this.getSelectedEvent.eventGenderPrices.map(eventGenderPrice => {
                //         eventGenderPrice.id = null
                //         eventGenderPrice.productGenderPriceComponents.map(productGenderPriceComponent => {
                //             productGenderPriceComponent.id = null
                //         })
                //     })
                // }

                //set "has tax"
                // this.getSelectedEvent.eventGenderPrices = this.getSelectedEvent.helperProduct.productGenderPrices

                //set routes
                this.getSelectedEvent.eventRoutes = this.getSelectedEvent.helperProduct.routes

                //set product
                this.getSelectedEvent.product = this.getSelectedEvent.helperProduct
                // this.getSelectedEvent.product.name = this.getSelectedEvent.helperProduct.name

                //set location
                this.getSelectedEvent.location = !this.getSelectedEvent.location ? this.getSelectedEvent.helperProduct.location : this.getSelectedEvent.location
            },
            changeCategorySelected: function() {
            },
        },
        components: {
          Datepicker,
          Timepicker,
          vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// areaDateTime.vue?807e9bbe